export const PROJECT_TYPE_CLOUD_SUPPORT = "Cloud Support";
export const PROJECT_TYPE_CLOUD_EVALUATION_SUPPORT = "Cloud Evaluation Support";

export const CASE_CLOSED_STATE = "Closed";
export const CASE_OPEN_STATE = "Open";

export const CONSUMED_QUERY_HOURS = 'Consumed Query Hours';
export const REAMAINING_QUERY_HOURS = 'Remaining Query Hours';
export const HOURS = 'Hours';

export const CASE_TYPE_INCIDENT = 'Incident';
export const CASE_TYPE_QUERY = 'Query';
export const CASE_TYPE_ENGAGEMENT = 'Engagement';

export const COLOURS = [
  "#1F84A6", 
  "#25AAE1", 
  "#3EB5E5", 
  "#57C0E9",
  "#70CBED", 
  "#89D6F1", 
  "#A2E1F5", 
  
];

export const DEBOUNCE_DELAY = 500;

export const TOOLTIP_TEXT = {
    goLive: "Risk if the project has not gone live within the expected timeframe (6 Months).",
    support: "Risk if the customer has not raised any support cases in the last 6 months.",
    eol: "Risk if the customer is currently using a software version that is End-of-Life.",
    abandoned: "Risk if there are abandoned product migration cases.",
    delays: "Risk if there are delayed migration cases.",
    escalations: "Risk if the account has more than 2 escalations in the last 3 months.",
    healthStatus: "Manually set from the account detail page. If any single project is marked At Risk, the account is considered At Risk."
};
